export default [
  {
    path: '/bet-setting',
    name: 'bet-setting',
    component: () => import('@/views/betSetting/BetSetting.vue'),
    meta: {
      pageTitle: 'breadcrumb.betSetting',
      resource: 'bet-setting',
      navActiveTab: 'bet-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.betSetting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payout-setting',
    name: 'payout-setting',
    component: () => import('@/views/betSetting/payoutSetting/Index.vue'),
    meta: {
      pageTitle: 'breadcrumb.payoutSetting',
      resource: 'bet-setting',
      navActiveLink: 'bet-setting',
      navActiveTab: 'payout-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.payoutSetting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/time-setting',
    name: 'time-setting',
    component: () => import('@/views/betSetting/timeSetting/Index.vue'),
    meta: {
      pageTitle: 'breadcrumb.timeSetting',
      resource: 'bet-setting',
      navActiveLink: 'bet-setting',
      navActiveTab: 'time-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.timeSetting',
          active: true,
        },
      ],
    },
  },
]
